import httpUtil from "@/utils/httpUtil";

export const selectBatchList = params => httpUtil.get("/pageBatch/list", params);
export const selectPageList = params => httpUtil.get("/pageBatch/pageList", params);

